"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { useActivePersona } from "@/lib/persona";

/**
 * Slim identity strip (H1 / D3) — replaces the fold-consuming ACCOUNT card.
 * One line: display name + district + masked account number, linking to
 * /account where the full address and account detail live (progressive
 * disclosure). Frees a fold slot on every persona so the balance sits higher.
 */
export function IdentityStrip() {
  const persona = useActivePersona();
  return (
    <Link
      href="/account"
      className="card-surface flex items-center justify-between gap-3 hover:shadow-lg transition-shadow duration-base group"
    >
      <div className="min-w-0">
        <p className="text-sm font-medium text-neutral-900 truncate">
          {persona.displayName}
        </p>
        <p className="text-xs text-neutral-500 truncate">
          {persona.serviceAddress.district}
        </p>
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0">
        <span className="text-xs font-mono text-neutral-500">#{persona.accountNumber}</span>
        <ChevronRight
          size={14}
          className="text-neutral-500 group-hover:translate-x-0.5 transition-transform duration-fast"
          aria-hidden
        />
      </div>
    </Link>
  );
}
